module.exports = __webpack_public_path__ + "img/icon_sportMenu_handball.bfbefb8c.svg";